module.exports = __webpack_public_path__ + "img/industry_map.49dcf4a4.png";